<template>
  <div class="container">
    <QueryFrame
        @handlePage='handlePage'
        @handlePageSize='handlePageSize'
        idText='商品ID:'

        :count="count"
        :current='page'
        >
          <div slot="queryParams" class="form">
        <div >
<div>
  <span>商品ID：</span><span>{{goodsInfo.drugSerialCode}}</span>
</div>
<div class="subInfos">

    <span>商品通用名：{{goodsInfo.approvedDrugNames}}</span>
    <span>批准文号：{{goodsInfo.approvalNumber}}</span>
    <span>规格：{{goodsInfo.specifications}}</span>

</div>
        </div>
        <div class="queryContainer">
          <div class="queryItem">
        <label>关键词:</label>
            <lk-input :maxlength='100' class="item" placeholder='请输入' clearable v-model='query.storeAndSupplier'></lk-input>
             </div>
                <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(true)">查询</lk-button>
            <lk-button @click="clearForm">重置</lk-button>
          </div>
          </div>
          </div>

      <div slot="table">
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import goodsBase from '../../../services/goods';
import utils from '../../../libs/utils';
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import mapState from '../../../mixins/mapState';
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'StoreFirst',
  components: { QueryFrame },
  mixins: [mapState, queryMixins],
  data() {
    return {
      id: '', // 药品ID
      titleInfo: [],
      approvalStatusArr: ['', '草稿', '审批中', '审批通过', '审批拒绝'],
      paymentTypeArr: [],
      curingStandardArr: ['', '一般养护', '重点养护'],
      goodsInfo: {},
      query: {
        storeAndSupplier: '',
      },
      params: {
        storeAndSupplier: '',
      },
      columns: [
        // { title: 'ID', key: 'id' },
        { title: '申请单号', key: 'applyCode', minWidth: 116 },
        { title: '门店名称', key: 'storeName' },
        { title: '首营审批状态', key: 'approvalStatus' },
        { title: '助记码', key: 'mnemonicCode' },
        { title: '供应商', key: 'supplierStoreName' },
        { title: '成本类型', key: 'paymentType' },
        { title: '默认进货价', key: 'defPurchasePrice' },
        { title: '进项税率', key: 'inputTaxRate' },
        { title: '默认销售价', key: 'defRetailPrice' },
        { title: '销项税率', key: 'outputTaxRate' },
        { title: '养护类型', key: 'curingStandard' },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 120,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'storeFirstInfo', params: { id: params.row.id } });
                },
              },
            }, '查看'),
          ]),
        },
      ],
      tableData: [],
      // page: 1,
      // size: 10,
      count: 0,
    };
  },
  mounted() {
    this.getPaymentTypeArr().then(() => {
      this.getGoodsInfo();
    });
    // this.onQuery();
    this.handleSearch(true);
  },
  methods: {
    clearForm() {
      this.query.storeAndSupplier = '';
    },
    getGoodsInfo() {
      goodsBase.getGoodsBaseById({ id: this.$route.params.id }).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          this.goodsInfo = data.data.goodsBase;
          // this.goodsInfo.storeName = data.data.goodsBase;
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.goodsBaseId = this.$route.params.id;
      this.params.page = this.page;
      this.params.size = this.size;
      goodsBase.listGoodsStores(this.params).then((responseData) => {
        if (responseData.data.status === 200) {
          this.tableData = [];
          this.count = responseData.data.data.count;
          responseData.data.data.list.forEach((item) => {
            const result = {};
            // console.log(item);
            utils.exchangeTable(item.goodsStore, result);
            result.approvalStatus = this.approvalStatusArr[item.goodsStore.approvalStatus];
            result.paymentType = this.paymentTypeArr[item.goodsStore.paymentType];
            result.curingStandard = this.curingStandardArr[item.goodsStore.curingStandard];
            result.loading = false;
            // result.defPurchasePrice = utils.exchangePercent(result.defPurchasePrice);
            // result.defRetailPrice = utils.exchangePercent(result.defRetailPrice);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(responseData.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handlePage(page) {
    //   this.page = page;
    //   this.onQuery();
    // },
    // handlePageSize(size) {
    //   this.size = size;
    //   this.onQuery();
    // },
    getPaymentTypeArr() {
      return new Promise((resolve) => {
        goodsBase.GoodsDictionary({ dictionaryTypeEnum: 7 }).then((res) => {
          if (res.data.status === 200) {
            this.paymentTypeArr[0] = '';
            res.data.data.forEach((item) => {
              this.paymentTypeArr.push(item.dictionaryName);
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
  },
};
</script>

<style lang=less scoped>
.subInfos{
  padding-bottom: 20px;
  >span{
    padding-right: 20px
  }
}
</style>
